import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Modal, Row, Col, Form, OverlayTrigger } from "react-bootstrap";
import { MdEdit, MdAddCircle, MdFilterList, MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Header from '../../components/layout/header/header';
import LeftNav from '../../components/layout/leftNav/leftNav';
import axios from "axios";
import DataTable from "react-data-table-component";
import { Tooltip } from '@mui/material';
import loading from "../../assets/images/common/loading.gif";
import AppDataGrid from '../../components/common/AppDataGrid';


const Roles = () => {
    const [Roles, setRoles] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();
    const handleCloseFilterModal = () => setShowFilterModal(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleShowFilterModal = () => setShowFilterModal(true);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [isLoading, setIsLoading] = useState(true);
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const readOnlyRoles = ["Class Teacher", "Teacher", "Class Incharge", "School Admin"];
    const canSubmit = !readOnlyRoles.includes(userObj.role_name?.trim());
    const [filter, setFilter] = useState({
        role_name: "",
        action: "FILTER"
    });

    const handleEditClick = (role_id) => {
        const employeemasterToEdit = Roles.find(roles => roles.role_id === role_id);

        if (employeemasterToEdit) {
            navigate("/AddRoles", { state: { rolesData: employeemasterToEdit } });
        } else {
            console.error("Role with ID ${ role_id } not found");
        }
    };
    useEffect(() => {
        setIsLoading(true);
        fetchRoles().finally(() => setIsLoading(false));
    }, []);


    const fetchRoles = async () => {
        try {
            const response = await axios.post(baseUrl + "/role/", {
                action: "READ",
                school_id: userObj.school_id
            });
            setRoles(response.data);
        } catch (error) {
            console.error("Error fetching roles:", error);

        }
    };

    const columns = [
        {
            field: 'role_name',
            headerName: 'Role',
            flex: 1,
            headerAlign: 'center',
            align: "center",
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },

        {
            field: 'is_active',
            headerName: 'Status',
            flex: 1,
            headerAlign: 'center',
            align: "center",
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },
        ...(canSubmit ? [{
            field: 'actions',
            headerName: "Actions",
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div className="tableActions">
                    <span className="commonActionIcons" onClick={() => handleEditClick(params.row.role_id)}>
                        <MdEdit />
                    </span>
                    <span className="commonActionIcons" onClick={() => handleDeleteClick(params.row.role_id)}>
                        <MdDelete />
                    </span>
                </div>

            ),

        }] : [])

    ];

    const handleDeleteClick = async (role_id) => {
        const confirmDelete = window.confirm('Are you sure you want to change the status?');
        if (!confirmDelete) {
            return;
        }
        const requestBody = {
            role_id: role_id,
            action: "DELETE"
        };
        try {
            const response = await axios.post(baseUrl + '/role/', requestBody, {
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            if (response.status < 200 || response.status >= 300) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            toast.success("Record Set to InActive");
            fetchRoles();
        } catch (error) {
            console.error('Error:', error);
        }
    };
    const searchableColumns = [
        (row) => row.role_name,
        (row) => row.is_active,

    ];

    const filteredRecords = (Roles || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item);
            const stringValue = String(value || '').toUpperCase().replace(/[-\s]+/g, '');
            const normalizedQuery = searchQuery.toUpperCase().replace(/[-\s]+/g, '');
            return stringValue.includes(normalizedQuery);
        })
    );

    const handleFilterSubmit = async (e) => {
        e.preventDefault();
        const formData = {
            role_name: filter.role_name || "",
            action: "FILTER",
        };

        try {
            const response = await axios.post(baseUrl + "/role/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const dataArray = Array.isArray(response.data) ? response.data : [];
            setRoles(dataArray);

            setFilter((prevFilter) => ({
                ...prevFilter,
            }));
            setShowFilterModal(false);

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleReset = async (e) => {
        e.preventDefault();
        setFilter({
            role_name: "",
        });
        setShowFilterModal(true);

        fetchRoles();
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    return (
        <div className="pageBody">
            <ToastContainer />
            <div className="commonDataTableHead">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <h6 className="commonTableTitle">Roles</h6>
                    </div>
                    <div className="">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            className="searchInput"
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                            <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                                <MdFilterList />
                            </Button>
                        </OverlayTrigger>

                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add</Tooltip>}>
                            <Button className="primaryBtn" variant="primary" onClick={() => navigate("/AddRoles")}>
                                <MdAddCircle />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>

            <div className="commonTable">
                <div className="tableBody">
                    {isLoading ? (
                        <div className="loadingContainer">
                            <img src={loading} alt="Loading..." className="loadingGif" />
                        </div>
                    ) : (
                        <AppDataGrid
                            rows={filteredRecords.length ? filteredRecords : []}
                            columns={columns}
                            getRowId={(row) => row.role_id}
                            pageSizeOptions={[10, 20, 50]}      // Dropdown options
                            showToolbar={false}
                            pagination
                            density="compact"
                            maxHeight={550}
                        />
                    )}
                </div>
            </div>
            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBodyScrollable">
                    <Row>
                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="role_name">
                                    <Form.Label>Role </Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="role_name"
                                        name="role_name"
                                        placeholder="Enter Role "
                                        maxLength={30}
                                        value={filter.role_name}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[^A-Za-z]/g, '');
                                            setFilter({ ...filter, role_name: value });
                                        }}

                                    />
                                </Form.Group>
                            </div>
                        </Col>

                    </Row>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleReset}>
                        Reset
                    </Button>
                    <div>
                        <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={() => { handleCloseFilterModal(); }}>
                            Cancel
                        </Button>
                        <Button variant="primary" className="btn-success primaryBtn" onClick={handleFilterSubmit}>
                            Search
                        </Button></div>
                </Modal.Footer>

            </Modal>
        </div>
    );
};

export default Roles;
